import React, { Component } from "react";
import { connect } from "react-redux";
import { ThemeProvider } from "emotion-theming";
import { Switch, Route, withRouter, matchPath } from "react-router-dom";
import { message } from "antd";
import moment from "moment";
import APPLICATION_ROUTES, { NAVBAR_LINKS, USER_PROFILE_MENU } from "../routes";
import defaultTheme from "../styles";
import baseActions from "../actions";
import NavBar from "../components/NavBar";
import RelocatableDrawer from "../components/RelocatableDrawer";
import { SCENARIOS, CONFIG, USER_INFO, PERSIST_PARAMS } from "../plannerConfig";

const mapStateToProps = (state) => ({
  [CONFIG]: state[CONFIG],
  [USER_INFO]: state[USER_INFO],
  [PERSIST_PARAMS]: state[PERSIST_PARAMS].data,
  [SCENARIOS]: state[SCENARIOS].data.results,
});

const mapDispatchToProps = {
  get: baseActions.get,
  set: baseActions.set,
};

const generateTheme = (clientTheme) => ({
  ...defaultTheme,
  clientTheme,
});

export class RosterPlannerComponent extends Component {
  state = {
    relocatableDrawerVisible: false,
    relocatableDrawerContent: null,
  };

  componentDidMount() {
    const { get, persistParams, location, history } = this.props;
    message.config({ maxCount: 1 });

    get([CONFIG, USER_INFO]);

    // If user change the url manually and the url is valid, respect the user's change.
    let usePersistPath = true;
    if (persistParams.pathname !== location.pathname) {
      const allPaths = Object.values(APPLICATION_ROUTES)
        .filter((obj) => obj.path !== "*" && obj.path !== "/")
        .map((obj) => obj.path);

      if (allPaths.find((path) => matchPath(location.pathname, path))) {
        usePersistPath = false;
      }
    }

    // If url is invalid, use the one stored in persist params - in localstorage.
    if (usePersistPath && persistParams && persistParams.pathname) {
      history.replace(persistParams.pathname);
    }

    // No valid url and persist params, use default.
    if (!persistParams || !persistParams.pathname) {
      history.replace(
        `/dashboards/0/date/${moment().format("YYYY-MM-DD")}/range/7/offset/0`
      );
    }
  }

  handleClickOpenRelocatableDrawer = (component) => {
    this.setState({
      relocatableDrawerVisible: true,
      relocatableDrawerContent: component,
    });
  };

  handleClickCloseRelocatableDrawer = () => {
    this.setState({ relocatableDrawerVisible: false });
  };

  render() {
    const { relocatableDrawerVisible, relocatableDrawerContent } = this.state;
    const { userInfo, config, persistParams, scenarios, location } = this.props;
    const theme = generateTheme(config.data.theme);

    // Load the config first before returning application
    if (!Object.keys(config.data).length || config.loadingQueue.length) {
      return null;
    }

    return (
      <ThemeProvider theme={theme}>
        <>
          <NavBar
            navbarLinks={NAVBAR_LINKS}
            userProfileMenuOptions={USER_PROFILE_MENU}
            userProfile={userInfo.data}
            routeParams={persistParams}
            currentScenario={
              scenarios &&
              scenarios.find((item) => item.id === persistParams.scenario)
            }
            config={config}
            location={location}
          />

          <RelocatableDrawer
            visible={relocatableDrawerVisible}
            onClose={this.handleClickCloseRelocatableDrawer}
            drawerComponent={relocatableDrawerContent}
          />

          <Switch>
            {APPLICATION_ROUTES.map(({ name, path, component }) => {
              const RouteComponent = component;
              return (
                <Route
                  key={name}
                  path={path}
                  render={(routeProps) => (
                    <RouteComponent
                      {...routeProps}
                      onClickOpenRelocatableDrawer={
                        this.handleClickOpenRelocatableDrawer
                      }
                    />
                  )}
                />
              );
            })}
          </Switch>
        </>
      </ThemeProvider>
    );
  }
}

// withRouter is used so that url being pushed to the history would change page.
// Please refer to the following link.
// https://stackoverflow.com/questions/45056150/react-router-v4-not-working-with-redux
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(RosterPlannerComponent)
);
